import React from 'react';
import { DeleteModalView } from './delete-modal-view';
import { InvalidDeleteModalView } from './invalid-delete-modal-view';

export type DeletePrioritySchemeModalWrapperProps = {
	isSubmitting: boolean;
	associatedProjectCount: number;
	schemeName: string;
	onComplete: () => void;
	onSubmit: () => void;
};

export const DeletePrioritySchemeModalWrapper = ({
	isSubmitting,
	associatedProjectCount,
	schemeName,
	onComplete,
	onSubmit,
}: DeletePrioritySchemeModalWrapperProps) =>
	associatedProjectCount > 0 ? (
		<InvalidDeleteModalView
			schemeName={schemeName}
			onComplete={onComplete}
			associatedProjectCount={associatedProjectCount}
		/>
	) : (
		<DeleteModalView
			isSubmitting={isSubmitting}
			schemeName={schemeName}
			onComplete={onComplete}
			onSubmit={onSubmit}
		/>
	);
